/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Instagram_Review_Cies_Recommendation_AltInputs */

const es_landing_instagram_review_cies_recommendation_alt = /** @type {(inputs: Landing_Instagram_Review_Cies_Recommendation_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia de Instagram de carla_dipinto recomendando alquilar barco con Zarpar en las Cíes`)
};

const gl_landing_instagram_review_cies_recommendation_alt = /** @type {(inputs: Landing_Instagram_Review_Cies_Recommendation_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historia de Instagram de carla_dipinto recomendando alugar barco con Zarpar nas Cíes`)
};

const en_landing_instagram_review_cies_recommendation_alt = /** @type {(inputs: Landing_Instagram_Review_Cies_Recommendation_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram story by carla_dipinto recommending boat rental with Zarpar in the Cíes`)
};

/**
* | output |
* | --- |
* | "Instagram story by carla_dipinto recommending boat rental with Zarpar in the Cíes" |
*
* @param {Landing_Instagram_Review_Cies_Recommendation_AltInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_instagram_review_cies_recommendation_alt = /** @type {((inputs?: Landing_Instagram_Review_Cies_Recommendation_AltInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Instagram_Review_Cies_Recommendation_AltInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_instagram_review_cies_recommendation_alt(inputs)
	if (locale === "en") return en_landing_instagram_review_cies_recommendation_alt(inputs)
	return es_landing_instagram_review_cies_recommendation_alt(inputs)
});